<template>
  <!-- This layout used to show Landing Page -->
  <div>
    <slot />
    <NotificationList />
  </div>
</template>

<script>
import NotificationList from "@/components/NotificationList.vue"
export default {
  components: {
    NotificationList
  }
};
</script>

<style scoped>

</style>